import { render, staticRenderFns } from "./CreateShift.vue?vue&type=template&id=88d8b7cc&scoped=true"
import script from "./CreateShift.vue?vue&type=script&lang=js"
export * from "./CreateShift.vue?vue&type=script&lang=js"
import style0 from "./CreateShift.vue?vue&type=style&index=0&id=88d8b7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d8b7cc",
  null
  
)

export default component.exports